import type { ReactNode } from "react";

import { m } from "@/paraglide/messages";

/** The one reading order shared by creating and editing a statement tree. */
export function StatementTreeLayout({
  identity,
  actions,
  notice,
  sourceQuery,
  rows,
}: Readonly<{
  identity: ReactNode;
  actions?: ReactNode;
  notice?: ReactNode;
  // corporate finance trees carry no source query of their own
  sourceQuery?: ReactNode;
  rows: ReactNode;
}>) {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex min-w-0 flex-1 items-start gap-3">{identity}</div>
        {actions}
      </div>
      {notice}
      {sourceQuery && (
        <>
          <h2 className="text-text-primary text-lg font-semibold">
            {m.ledger_query_title()}
          </h2>
          {sourceQuery}
          <h2 className="text-text-primary text-lg font-semibold">
            {m.template_editor_category_statement_trees()}
          </h2>
        </>
      )}
      <p className="text-text-tertiary text-sm">
        {m.statement_taxonomy_editor_sign_hint()}
      </p>
      {rows}
    </div>
  );
}
